import type { VaultRecord } from "../types";

function stableRecordValue(record: VaultRecord): string {
  const value = { ...record } as Record<string, unknown>;
  delete value.id;
  delete value.updatedAt;
  return JSON.stringify(value);
}

export function shouldPreserveConflictCopy(local: VaultRecord, remote: VaultRecord | null): boolean {
  if (local.kind !== "note" && local.kind !== "secret") return false;
  if (!remote || local.kind !== remote.kind) return true;
  return stableRecordValue(local) !== stableRecordValue(remote);
}
